import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'playground-traveler-dialog',
  templateUrl: './playground-traveler-dialog.component.html',
  standalone: false
})
export class PlaygroundTravelerDialogComponent implements OnInit {
  @Input() salesOrderId!: number;
  @Input() suggestedTravelerId = 9000001;

  form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<PlaygroundTravelerDialogComponent>
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      travelerId: [this.suggestedTravelerId, Validators.required],
      travelerName: ['', Validators.required],
      email: [''],
      phone: [''],
      mobilePhone: [''],
      dateOfBirth: [null],
      gender: [''],
      passportNumber: [''],
      passportCountry: [''],
      passportFullName: [''],
      passportExpiryDate: [null],
      passportIssueDate: [null],
      address1: [''],
      address2: [''],
      city: [''],
      state: [''],
      country: [''],
      postalCode: [''],
      isMainContact: [false]
    });
  }

  save(): void {
    if (!this.form.valid) {
      return;
    }
    const v = this.form.value;
    const toIso = (d: unknown): string | null => d instanceof Date ? d.toISOString().substring(0, 10) : (d as string) || null;
    this.dialogRef.close({
      salesOrderId: this.salesOrderId,
      travelerId: v.travelerId,
      travelerName: v.travelerName,
      email: v.email,
      phone: v.phone,
      mobilePhone: v.mobilePhone,
      dateOfBirth: toIso(v.dateOfBirth),
      gender: v.gender,
      passportNumber: v.passportNumber,
      passportCountry: v.passportCountry,
      passportFullName: v.passportFullName,
      passportExpiryDate: toIso(v.passportExpiryDate),
      passportIssueDate: toIso(v.passportIssueDate),
      address1: v.address1,
      address2: v.address2,
      city: v.city,
      state: v.state,
      country: v.country,
      postalCode: v.postalCode,
      isMainContact: v.isMainContact
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
